import { render } from "./landingPage.vue?vue&type=template&id=462f6140&scoped=true"
import script from "./landingPage.vue?vue&type=script&lang=js"
export * from "./landingPage.vue?vue&type=script&lang=js"

import "./landingPage.vue?vue&type=style&index=0&id=462f6140&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462f6140"]])

export default __exports__